import { formatNumber } from '@angular/common';

export function formatCents(value: number, locale: string): string {
  return formatNumber(value, locale, '1.0-1');
}
